/**
 * カスタムアコーディオン アニメーション制御
 * 開閉のたびにアニメーションを再トリガーする
 */
class AccordionAnimator {
  constructor() {
    this.pendingAnimations = new WeakMap();
    this.init();
  }

  init() {
    // すべてのアコーディオンdetails要素を取得
    const accordions = document.querySelectorAll('.accordion__details');
    
    accordions.forEach((details) => {
      const content = details.querySelector('.accordion__content-wrapper');
      if (!content) return;

      // toggleイベントを監視
      details.addEventListener('toggle', () => {
        this.handleToggle(details, content);
      });

      // 初期状態で開いている場合はアニメーションクラスを付与
      if (details.open) {
        content.classList.add('is-animating');
      }
    });
  }

  handleToggle(details, content) {
    // 保留中のアニメーションフレームをキャンセル
    const pendingFrame = this.pendingAnimations.get(content);
    if (pendingFrame) {
      cancelAnimationFrame(pendingFrame);
      this.pendingAnimations.delete(content);
    }

    if (details.open) {
      // 開く時：アニメーションを強制リセットして再スタート
      content.classList.remove('is-animating');
      
      // アニメーションを完全にリセット（reflow を強制）
      content.style.animation = 'none';
      content.offsetHeight; // reflow をトリガー
      content.style.animation = '';
      
      // 次のフレームでクラスを追加
      const frameId = requestAnimationFrame(() => {
        content.classList.add('is-animating');
        this.pendingAnimations.delete(content);
      });
      this.pendingAnimations.set(content, frameId);
    } else {
      // 閉じる時：アニメーションクラスを削除
      content.classList.remove('is-animating');
    }
  }
}

// DOM読み込み完了後に初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new AccordionAnimator());
} else {
  new AccordionAnimator();
}

